import { datadogRum } from '@datadog/browser-rum';
import { Amplify } from 'aws-amplify';
import { AppLayout } from 'components/shell';
import { GraphqlWrapper } from 'components/shell/graphql-wrapper';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { DemoNamesProvider } from 'providers/demo-mode';
import { SnackbarProvider } from 'providers/snackbar';
import { FC } from 'react';
import { BrowserRouter } from 'react-router';
import { Router } from 'router';
import AuthWrapper from './components/shell/auth-wrapper';
import amplifyConfigs from './configs/amplify-config';

const VITE_LAUNCH_DARKLY_KEY = import.meta.env.VITE_LAUNCH_DARKLY_KEY;

const VITE_DATADOG_APPLICATION_ID = import.meta.env.VITE_DATADOG_APPLICATION_ID;
const VITE_DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
const VITE_DATADOG_SESSION_SAMPLE_RATE: number = import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE
  ? Number(import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE)
  : 100;
const VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE: number = import.meta.env
  .VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE
  ? Number(import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE)
  : 100;
const VITE_DATADOG_ENV = import.meta.env.VITE_DATADOG_ENV;

const config = amplifyConfigs();
if (config.Auth?.Cognito.userPoolId && config.Auth?.Cognito.userPoolClientId) {
  Amplify.configure(config);
}

if (VITE_DATADOG_CLIENT_TOKEN && VITE_DATADOG_APPLICATION_ID && VITE_DATADOG_ENV) {
  datadogRum.init({
    applicationId: VITE_DATADOG_APPLICATION_ID,
    clientToken: VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'admin-ui',
    env: VITE_DATADOG_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: VITE_DATADOG_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

datadogRum.startSessionReplayRecording();

export const App: FC = () => {
  return (
    <BrowserRouter>
      <AuthWrapper>
        <DemoNamesProvider>
          <SnackbarProvider>
            <GraphqlWrapper>
              <AppLayout>
                <Router />
              </AppLayout>
            </GraphqlWrapper>
          </SnackbarProvider>
        </DemoNamesProvider>
      </AuthWrapper>
    </BrowserRouter>
  );
};

let WrappedApp = App as any;

if (VITE_LAUNCH_DARKLY_KEY) {
  WrappedApp = withLDProvider({
    clientSideID: VITE_LAUNCH_DARKLY_KEY as string,
  })(App);
}

export default WrappedApp;
